module.exports = __webpack_public_path__ + "static/media/favicon.d742e616.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 1927
// module chunks = 174